import React, { Fragment, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
// import { Link } from "react-router-dom";

import { bool, func, shape } from "prop-types";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
// import I18n from "pages/_components/I18n";

import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { useLocation, useParams } from "react-router-dom";
import FormattedDate from "pages/_components/FormattedDate";
import { formatNum } from "util/format";
import Button from "pages/_components/Button";

import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Avatar from "pages/_components/Avatar";
// import CustomHead from "pages/_components/CustomHead";
// import Button from "pages/_components/Button";

// eslint-disable-next-line import/no-named-as-default
import TransactionCard, {
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";

import CustomData from "pages/_components/CustomData/CustomData";
import { addUtcOffset } from "util/date";
import { isEmpty } from "lodash";
import { isIOS } from "react-device-detect";
import classNames from "classnames";
import { transactionStatus } from "pages/transactions/constants";

const NewDepositPendingTransaction = ({ dispatch, fetching, transaction, activeEnvironment, isDesktop }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const isBackoffice = pathname.includes("backoffice");
    const isLoading = fetching || !transaction?.data;
    const depositData = {
        idTransaction: transaction?.idTransaction || "",

        depositType: transaction?.data?.deposit?.depositType,
        investCapital: transaction?.data?.deposit?.amountInvested || 0,
        debitAccount: {
            number: transaction?.data?.deposit?.accreditedAccount?.number,
            productAlias: transaction?.data?.deposit?.accreditedAccount?.productAlias,
            productType: transaction?.data?.deposit?.accreditedAccount?.productType,
        },
        termInDays: transaction?.data?.deposit?.coreDeadline,
        expirationAction: transaction?.data?.deposit?.autoRenewal,

        currency: transaction?.data?.deposit?.depositType?.slice(-3),
        certificate: transaction?.data?.deposit?.depositNumber,
        earnedInterests: transaction?.data?.deposit?.interest || 0,
        chargeAmount: transaction?.data?.deposit?.amountTransfered || 0,
        tna: transaction?.data?.deposit?.rate,
        tea: transaction?.data?.deposit?.effectiveRate,
        expirationDate: transaction?.data?.deposit?.dueDate,
        creationDate: transaction?.data?.deposit?.openDate,
        cuitBiBank: transaction?.data?.deposit?.owner,
        cuitBusinness: transaction?.data?.deposit?.nationalIdentifier,
        profit: transaction?.data?.deposit?.profit,
        stamp: transaction?.data?.deposit?.stamp,
        jurisdiction: transaction?.data?.deposit?.jurisdiction,
        retentions: transaction?.data?.deposit?.retentions,
        iva: transaction?.data?.deposit?.vats,
    };
    const currencyString = i18n.get(`currency.label.${depositData?.currency}`);

    const [showMoreData, setShowMoreData] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    const { user } = useSelector((_state) => _state.session);

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(depositsActions.cleanDepositTicket());
        },
        [],
    );

    const handleSignTransaction = () => {
        const depositDetails = { ...transaction?.data?.deposit, idTransaction: transaction?.idTransaction };
        dispatch(depositsActions.setNewDepositData(depositDetails, transaction?.data?.token));
        dispatch(routerActions.push("/deposits/summaryForm"));
    };

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    return (
        <Fragment>
            <Notification scopeToShow="deposits" />
            <Notification scopeToShow="depositsTicket" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="deposits.summary.title"
                    metaTitle="deposits.summary.title"
                    backLinkTo={state.isCreationFlow ? "/deposits/requestForm" : "/desktop"}
                    className={isIOS ? "ticket-header whitespace-nowrap pt-8" : "ticket-header"}
                />
            )}

            <MainContainer showLoader={isLoading}>
                <TransactionCard transaction={transaction}>
                    <TransactionHeader title="deposits.summary.title" />
                    <div className="ticket">
                        <div className="ticket__wrapper">
                            <div className="ticket__header" />
                            <div className="ticket__body deposit-pending">
                                <div className="ticket-header-info">
                                    <div className="beneficiary">
                                        <div className="avatar-name">
                                            <Avatar
                                                user={{
                                                    userFullName: `${activeEnvironment?.name}` || "",
                                                    defaultAvatarId: "0",
                                                }}
                                            />
                                        </div>
                                        <div className="user-info">
                                            <div className="small">{i18n.get("deposits.applicant")}</div>
                                            <div className="large">{`${activeEnvironment?.name}`}</div>
                                            <div className="small">{`CUIT: ${activeEnvironment?.activeEnvironmentDocument}`}</div>
                                        </div>
                                    </div>
                                    <CustomData
                                        titleText="deposits.investCapital"
                                        titleTextType="I18N"
                                        valueClass="large"
                                        valueText={`${currencyString} ${formatNum(depositData?.investCapital, 2)}`}
                                    />
                                    <CustomData
                                        dataClass="amount tag tag-warning"
                                        titleText="deposits.chargeAmount"
                                        titleTextType="I18N"
                                        valueClass="large"
                                        valueText={`${currencyString} ${formatNum(depositData?.chargeAmount, 2)}`}
                                    />
                                </div>
                                <div className="view-more-data-button">
                                    <div className="ticket__divider inside-ticket__body">
                                        <div className="ticket__notch ticket__notch--left"> </div>
                                        <div className="ticket__notch ticket__notch--right"> </div>
                                    </div>
                                    <Button
                                        aria-expanded={showMoreData ? "true" : "false"}
                                        className="more-button"
                                        label={buttonLabel}
                                        bsStyle="link"
                                        onClick={handleSeeMoreData}
                                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                                    />
                                </div>
                                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                    <h2 className={isIOS && "mb-8"}>{i18n.get("creditBill.aditionalData.label")}</h2>
                                    <div className="ticket-section">
                                        <TransactionInfo
                                            field="deposits.certificateNumber"
                                            value={depositData?.certificate}
                                        />
                                        <TransactionInfo
                                            field="deposits.type"
                                            i18nId={`deposit.depositTypes.${depositData?.depositType}`}
                                        />
                                        <TransactionInfo
                                            withoutSpace
                                            field="deposits.debitAccount"
                                            value={`····${depositData?.debitAccount?.number?.slice(-6)} ${
                                                depositData?.debitAccount?.productType
                                            } ${currencyString}`}
                                        />
                                        <TransactionInfo
                                            field="deposits.earnedInterests"
                                            value={`${currencyString} ${formatNum(depositData?.earnedInterests, 2)}`}
                                        />
                                        <TransactionInfo field="deposits.creationDate">
                                            <FormattedDate
                                                date={addUtcOffset(depositData?.creationDate)}
                                                dateFormat="DD/MM/YYYY"
                                            />
                                        </TransactionInfo>
                                        <TransactionInfo field="deposits.expirationDate">
                                            <FormattedDate
                                                date={addUtcOffset(depositData?.expirationDate)}
                                                dateFormat="DD/MM/YYYY"
                                            />
                                        </TransactionInfo>
                                        <TransactionInfo field="deposits.termInDays" value={depositData?.termInDays} />
                                        <TransactionInfo
                                            field="deposits.tnaDetail"
                                            value={`${formatNum(depositData?.tna, 2)}%`}
                                        />
                                        <TransactionInfo
                                            field="deposits.teaDetail"
                                            value={`${formatNum(depositData?.tea, 2)}%`}
                                        />
                                        <TransactionInfo
                                            field="deposits.expirationAction.label"
                                            i18nId={`deposits.expirationAction.${depositData?.expirationAction}`}
                                        />
                                        <TransactionInfo field="deposits.cuitBiBank" value={depositData?.cuitBiBank} />
                                        <TransactionInfo
                                            field="deposits.cuitBusinness"
                                            value={depositData?.cuitBusinness}
                                        />
                                    </div>
                                    {depositData?.profit && (
                                        <>
                                            <div className="deposit-retentions ticket-section">
                                                <div className="ticket__divider inside-ticket__body">
                                                    <div className="ticket__notch ticket__notch--left"> </div>
                                                    <div className="ticket__notch ticket__notch--right"> </div>
                                                </div>
                                                <h2 className={isIOS && "mb-8"}>
                                                    <CustomData
                                                        titleText="deposits.retentions.perceptions"
                                                        titleTextType="I18N"
                                                    />
                                                </h2>
                                                <TransactionInfo
                                                    field="deposits.profits"
                                                    value={`${currencyString} ${formatNum(depositData?.profit, 2)}`}
                                                />

                                                {depositData?.stamp && (
                                                    <>
                                                        <TransactionInfo
                                                            field="deposits.stampCode"
                                                            value={`${currencyString} ${formatNum(
                                                                depositData?.stamp,
                                                                2,
                                                            )}`}
                                                        />
                                                        <TransactionInfo
                                                            field="deposits.jurisdiction"
                                                            value={depositData?.jurisdiction}
                                                        />
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}

                                    {/* ARBIBIMPLE-8763: Se solicita quitar seccion de IVA */}
                                    {/* <div className="deposit-iva ticket-section">
                                        <div className="ticket__divider inside-ticket__body">
                                            <div className="ticket__notch ticket__notch--left"> </div>
                                            <div className="ticket__notch ticket__notch--right"> </div>
                                        </div>
                                        <h2 className={isIOS && "mb-8"}>{i18n.get("deposits.IVA")}</h2>
                                        {depositData?.retentions?.map((ret) => (
                                            <TransactionInfo
                                                fieldString={ret.name}
                                                value={currencyString + formatNum(ret.value, 2)}
                                            />
                                        ))}
                                    </div> */}
                                    <TransactionSign
                                        creationTime
                                        showSignatures={false}
                                        isDesktop={isDesktop}
                                        noDate
                                        showMoreData={showMoreData}
                                    />
                                </div>
                            </div>
                            <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                        </div>
                    </div>
                </TransactionCard>

                {!isBackoffice && (
                    <Row className="form-actions">
                        <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                            <CustomButton
                                func={() => dispatch(routerActions.push("/desktop"))}
                                text="forms.transaction.ticket.actions.backToHome"
                                textType="I18N"
                                className={classNames(`btn${showSignButton ? " btn-outline" : " btn-primary"}`, {
                                    "mt-3": isIOS,
                                })}
                            />
                        </Col>
                        {showSignButton && (
                            <Col xs={12} md={4} mdOffset={6}>
                                <CustomButton
                                    func={handleSignTransaction}
                                    text="forms.signTransaction.link"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        )}
                    </Row>
                )}
            </MainContainer>
        </Fragment>
    );
};

NewDepositPendingTransaction.propTypes = {
    transaction: shape({}).isRequired,
    dispatch: func.isRequired,
    fetching: bool,
    isDesktop: bool,
    activeEnvironment: shape({}).isRequired,
};

NewDepositPendingTransaction.defaultProps = {
    fetching: false,
    isDesktop: false,
};

const mapStateToProps = (state) => ({
    depositTicketSignable: depositsSelectors.getDepositTicketSignable(state),
    transaction: formSelectors.getTransaction(state),
    fetching: depositsSelectors.getFetching(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(NewDepositPendingTransaction);
